export const fetcher = async (url: string, options: RequestInit | undefined) => {
    try {
        return await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            },
            ...options
        });
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};
